import useBodyScrollDisable from '#hooks/useBodyScrollDisable';
import { ModalConfirmState } from '#states/atoms/modalConfirmState';
import Portal from 'src/components/shared/Portal';
import * as S from './styles';

interface ModalConfirmProps extends Omit<ModalConfirmState, 'isVisible'> {
  handleClose: () => void;
}

export default function ModalConfirm({
  title,
  contents,
  confirmText,
  cancelText,
  onClickConfirm,
  onClickCancel,
  handleClose
}: ModalConfirmProps) {
  useBodyScrollDisable();

  const handleClickConfirm = async () => {
    if (onClickConfirm) {
      await onClickConfirm();
    }

    handleClose();
  };

  const handleClickCancel = async () => {
    if (onClickCancel) {
      await onClickCancel();
    }

    handleClose();
  };

  return (
    <Portal portalId="modal-confirm">
      <S.Root>
        <S.Bg />
        <S.Wrapper>
          {title && <S.Title>{title}</S.Title>}
          <S.Description>{contents}</S.Description>
          <S.ButtonGroup>
            <S.Button onClick={handleClickCancel}>
              {cancelText ?? '취소'}
            </S.Button>
            <S.ButtonPrimary onClick={handleClickConfirm}>
              {confirmText ?? '확인'}
            </S.ButtonPrimary>
          </S.ButtonGroup>
        </S.Wrapper>
      </S.Root>
    </Portal>
  );
}
